import { render } from "./HowToTakePicture.vue?vue&type=template&id=6da8c390&scoped=true&ts=true"
import script from "./HowToTakePicture.vue?vue&type=script&lang=ts"
export * from "./HowToTakePicture.vue?vue&type=script&lang=ts"

import "./HowToTakePicture.vue?vue&type=style&index=0&id=6da8c390&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da8c390"]])

export default __exports__